import shop from "../shop/shop";
import * as types from "../constant/ActionType";

export const fssetchsogsinUser = (data) => ({
    type: types.FETCH_LOGIN_DATA,
    data,
});
export const fetchcilDloginVerrr = (data) => ({
    type: types.VERIFICATION_LOGINN,
    data,
});

export const ForgetPasswordz = (data) => ({
    type: types.FORGET_PASSWORD,
    data,
});

export const UpdateLimit = (data) => ({
    type: types.UPDATE_RATE_LIMIT,
    data,
});

export const brandoownerRegis = (data) => ({
    type: types.REGISTER_BRAND_OWNER,
    data,
});

export const branduserfetchregister = (data) => ({
    type: types.REGISTER_BRAND_USER,
    data,
});

export const updatestatuscodes = (data) => ({
    type: types.UPDATE_STATUS_CODE,
    data,
});

export const specificroless = (data) => ({
    type: types.CREATE_ROLE,
    data,
});

export const Childassigpermissions = (data) => ({
    type: types.ASSIGN_PERMISSIONS,
    data,
});

export const childALLPermisssions = (data) => ({
    type: types.GETALL_PERMISSION,
    data,
});
export const rolePermissions = (data) => ({
    type: types.ROLE_PERMISSIONS,
    data,
});

export const contantAllviewroless = (data) => ({
    type: types.VIEW_ROLES,
    data,
});
export const viewOfAllUsers = (data) => ({
    type: types.VIEW_USERS,
    data,
});
export const viewOfAllProducts = (data) => ({
    type: types.VIEW_PRODUCTS,
    data,
});

export const viewReportProblem = (data) => ({
    type: types.VIEW_REPORT_PROBLEM,
    data,
});

export const getNumberOfSerialsForBatch = (data) => ({
    type: types.GET_SERIAL_FOR_BATCH,
    data,
});
export const getBatchByProducts = (data) => ({
    type: types.GET_BATCH_PRODUCT,
    data,
});

export const viewOfAllActiveProducts = (data) => ({
    type: types.VIEW_ACTIVE_PRODUCTS,
    data,
});
export const updateStatusUser = (data) => ({
    type: types.UPDATE_STATUS_USERS,
    data,
});

export const updateStatusBrand = (data) => ({
    type: types.UPDATE_STATUS_BRAND,
    data,
});

export const edituserChild = (data) => ({
    type: types.EDIT_USER,
    data,
});

export const allbrandgetchild = (data) => ({
    type: types.ALL_BRAND,
    data,
});

export const FetchallFAQs = (data) => ({
    type: types.ALL_FAQS,
    data,
});

export const FetchallTerms = (data) => ({
    type: types.ALL_TERMS,
    data,
});

export const brandgetoneDetails = (data) => ({
    type: types.BRAND_ONE_DETAIL,
    data,
});

export const brandediting = (data) => ({
    type: types.BRAND_EDIT,
    data,
});

export const getallcategeorychild = (data) => ({
    type: types.GETALL_CATEGEORY,
    data,
});

export const getAllActiveCompanies = (data) => ({
    type: types.GET_ALL_ACTIVE_COMPANIES,
    data,
});

export const getAllColorShift = (data) => ({
    type: types.GET_ALL_COLOR_SHIFT,
    data,
});

export const getAllActiveBrands = (data) => ({
    type: types.GET_ALL_ACTIVE_BRANDS,
    data,
});

export const categorystatusupdate = (data) => ({
    type: types.STATUS_UPDATE_CATEGORY,
    data,
});

export const SmsReplystatusupdate = (data) => ({
    type: types.STATUS_UPDATE_SMSREPLY,
    data,
});

export const categoryfetchregister = (data) => ({
    type: types.REGISTER_CATEGORY_STORE,
    data,
});

export const editcatgorychild = (data) => ({
    type: types.EDIT_CATEGORY,
    data,
});

export const editcolorshift = (data) => ({
    type: types.EDIT_COLOR_SHIFT,
    data,
});

export const editsmsReply = (data) => ({
    type: types.EDIT_SMSREPLY,
    data,
});

export const subcategorygetall = (data) => ({
    type: types.ALL_SUB_CATEGORIES,
    data,
});

export const smsReplygetAll = (data) => ({
    type: types.ALL_SMS_REPLY,
    data,
});
export const subcategoryupdatestats = (data) => ({
    type: types.SUB_CATEGORY_SATUS_UPDATE,
    data,
});

export const categorysubediting = (data) => ({
    type: types.EDIT_SUB_CATEGORY,
    data,
});

export const subcategorycreating = (data) => ({
    type: types.CREATE_SUB_CATEGORY,
    data,
});

export const actionCHildBatchesCSV = (data) => ({
    type: types.BY_BATCH_CSV_DATA,
    data,
});



export const allcompanyOAUTHchild = (data) => ({
    type: types.ALL_OAUTH_COMPANIES,
    data,
});



export const allcompanychild = (data) => ({
    type: types.ALL_COMPANY,
    data,
});

export const brandownerclientchild = (data) => ({
    type: types.BRAND_OWNER_CLIENTS,
    data,
});

export const brancclientrevoke = (data) => ({
    type: types.BRAND_CLIENTS_REVOKE,
    data,
});
export const brancclienttokenrevoke = (data) => ({
    type: types.BRAND_CLIENT_TOKEN_REVOKE,
    data,
});

export const branclienttokenchild = (data) => ({
    type: types.BRAND_CLIENT_TOKEN_DATA,
    data,
});


export const brandownerclientChangepasswordchild = (data) => ({
    type: types.BRAND_OWNER_CHANGE_PASSWORD,
    data,
});

export const createtokenchild = (data) => ({
    type: types.CREATE_TOKEN_BRAND,
    data,
});

export const brandowenerclientcrchild = (data) => ({
    type: types.BRAND_OWNER_CLIENTS_CREATE,
    data,
});





export const Progressive = (data) => ({
    type: types.PROGRESSIVE_CODES,
    data,
});
export const allBatchesActions = (data) => ({
    type: types.ALL_BATCHES,
    data,
});

export const allBatchesgetAllActions = (data) => ({
    type: types.ALL_BATCHES_BOTH_GET,
    data,
});

export const allCustomerGetActions = (data) => ({
    type: types.ALL_GET_CUSTOMER,
    data,
});

export const allCustomerActiveActions = (data) => ({
    type: types.ACTIVE_GET_CUSTOMER,
    data,
});

export const CustomerPostActions = (data) => ({
    type: types.ALL_POST_CUSTOMER,
    data,
});
export const CustomerUpdateActions = (data) => ({
    type: types.UPDATE_POST_CUSTOMER,
    data,
});

export const statusupdatecustomer = (data) => ({
    type: types.UPDATE_STATUS_CUSTOMER,
    data,
});

export const allCustomBatchesActions = (data) => ({
    type: types.ALL_CUSTOM_BATCHES,
    data,
});

export const allBatchesCompany = (data) => ({
    type: types.ALL_BATCHES_COMPANY,
    data,
});

export const createcompanies = (data) => ({
    type: types.CREATE_COMPANY,
    data,
});

export const statusupdatecompany = (data) => ({
    type: types.STATUS_UPDATE_COMPANY,
    data,
});

export const companydetailuser = (data) => ({
    type: types.COMPANY_DETAIL_ONE_USER,
    data,
});

export const allcount = (data) => ({
    type: types.All_COUNTS,
    data,
});

export const viewAllRandomCode = (data) => ({
    type: types.All_RANDOM_CODE,
    data,
});

export const postRandomCode = (data) => ({
    type: types.REQUEST_RANDOM_CODE,
    data,
});

export const viewCustombatch = (data) => ({
    type: types.VIEW_CUSTOM_BATCH,
    data,
});

export const postCustomsbatch = (data) => ({
    type: types.POST_CUSTOM_BATCH,
    data,
});
export const updateCustomsbatch = (data) => ({
    type: types.POST_UPDATE_CUSTOM_BATCH,
    data,
});

export const PostSMSReplies = (data) => ({
    type: types.POST_SMS_REPLY,
    data,
});
export const PostChangePassword = (data) => ({
    type: types.CHANGE_PASSWORD,
    data,
});

export const PostUpdateFAQs = (data) => ({
    type: types.POST_UPDATE_FAQS,
    data,
});

export const exportcsvchild = (data) => ({
    type: types.EXPORT_CSV,
    data,
});

export const exportcsvQRchild = (data) => ({
    type: types.EXPORT_QR_CSV,
    data,
});

export const PostUpdateTerms = (data) => ({
    type: types.POST_UPDATE_TERMS,
    data,
});

export const viewAllSMSLog = (data) => ({
    type: types.ALL_SMS_LOGS,
    data,
});

export const getcsv = (data) => ({
    type: types.GET_CSV,
    data,
});

export const viewAllSMSReport = (data) => ({
    type: types.ALL_SMS_REPORT,
    data,
});

export const viewAllQrcodeReport = (data) => ({
    type: types.ALL_QRCODE_REPORT,
    data,
});

export const CompanyCsv = (data) => ({
    type: types.EXPORT_CSV_COMPANY,
    data,
});
export const ReportProblemCsv = (data) => ({
    type: types.EXPORT_CSV_REPORT_PROBLEM,
    data,
});

export const exportCsvcategory = (data) => ({
    type: types.EXPORT_CSV_CATEGORYIES,
    data,
});

export const exportcsvCodeRandoms = (data) => ({
    type: types.EXPORT_CSV_RANDOM_CODE,
    data,
});

export const childdaTapostpreee = (data) => ({
    type: types.PER_POST_ID,
    data,
});

export const mapData = (data) => ({
    type: types.MAP_DATA,
    data,
});

export const childexportcustombattc = (data) => ({
    type: types.ALL_CUSTOMBATCH_EXPORT,
    data,
});

export const fetchedallcode = (data) => ({
    type: types.FETCHCODERANGE,
    data,
});

export const PostDataFetchGeting = (data) => (dispatch) => {
    shop.PostDataFetchGeting(data, (e) => {
        dispatch(childdaTapostpreee(e, data));
    });
};

export const FetchMapingData = (data) => (dispatch) => {
    shop.FetchMapingData(data, (e) => {
        dispatch(mapData(e, data));
    });
};

export const ExportCSVRadmonCOde = (data) => (dispatch) => {
    shop.ExportCSVRadmonCOde(data, (e) => {
        dispatch(exportcsvCodeRandoms(e, data));
    });
};

export const fetchALlDataExportCSVCategoeries = (data) => (dispatch) => {
    shop.fetchALlDataExportCSVCategoeries(data, (e) => {
        dispatch(exportCsvcategory(e, data));
    });
};

export const FetchCSVCmpanyAll = (data) => (dispatch) => {
    shop.FetchCSVCmpanyAll(data, (e) => {
        dispatch(CompanyCsv(e, data));
    });
};
export const FetchCSVReportProblem = (data) => (dispatch) => {
    shop.FetchCSVReportProblem(data, (e) => {
        dispatch(ReportProblemCsv(e, data));
    });
};

export const FetchRegisterBrandOwnerr = (data) => (dispatch) => {
    shop.FetchRegisterBrandOwnerr(data, (e) => {
        dispatch(brandoownerRegis(e, data));
    });
};

export const FetchCreateCompany = (data) => (dispatch) => {
    shop.FetchCreateCompany(data, (e) => {
        dispatch(createcompanies(e, data));
    });
};

export const fetchRegisterBrandUserrs = (data) => (dispatch) => {
    shop.fetchRegisterBrandUserrs(data, (e) => {
        dispatch(branduserfetchregister(e, data));
    });
};

export const FetchExportCSV = (data) => (dispatch) => {
    shop.FetchExportCSV(data, (e) => {
        dispatch(exportcsvchild(e, data));
    });
};

export const FetchExportQRCSV = (data) => (dispatch) => {
    shop.FetchExportQRCSV(data, (e) => {
        dispatch(exportcsvQRchild(e, data));
    });
};

export const RegisterProductz = (data) => (dispatch) => {
    shop.RegisterProductz(data, (e) => {
        dispatch(branduserfetchregister(e, data));
    });
};

export const UpdateStatusCode = (data) => (dispatch) => {
    shop.UpdateStatusCode(data, (e) => {
        dispatch(updatestatuscodes(e, data));
    });
};
export const fetchLoginUser = (data) => (dispatch) => {
    shop.fetchLoginUser(data, (e) => {
        dispatch(fssetchsogsinUser(e, data));
    });
};

export const DiubleVerificationLoginn = (data) => (dispatch) => {
    shop.DiubleVerificationLoginn(data, (e) => {
        dispatch(fetchcilDloginVerrr(e, data));
    });
};

export const ForgetPassword = (data) => (dispatch) => {
    shop.ForgetPassword(data, (e) => {
        dispatch(ForgetPasswordz(e, data));
    });
};
export const VerifyOTP = (data) => (dispatch) => {
    shop.VerifyOTP(data, (e) => {
        dispatch(ForgetPasswordz(e, data));
    });
};

export const CreateFetchRolee = (data) => (dispatch) => {
    shop.CreateFetchRolee(data, (e) => {
        dispatch(specificroless(e, data));
    });
};
export const EditRole = (data) => (dispatch) => {
    shop.EditRole(data, (e) => {
        dispatch(specificroless(e, data));
    });
};

export const FetchAllUsersView = (data) => (dispatch) => {
    shop.FetchAllUsersView(data, (e) => {
        dispatch(viewOfAllUsers(e, data));
    });
};
export const FetchAllProductz = (data) => (dispatch) => {
    shop.FetchAllProductz(data, (e) => {
        dispatch(viewOfAllProducts(e, data));
    });
};

export const GetReportProblem = (data) => (dispatch) => {
    shop.GetReportProblem(data, (e) => {
        dispatch(viewReportProblem(e, data));
    });
};

export const BatchProductSerialNo = (data) => (dispatch) => {
    shop.BatchProductSerialNo(data, (e) => {
        dispatch(getNumberOfSerialsForBatch(e, data));
    });
};

export const getBatchByProductID = (data) => (dispatch) => {
    shop.getBatchByProductID(data, (e) => {
        dispatch(getBatchByProducts(e, data));
    });
};

export const FetchAllActiveProducts = (data) => (dispatch) => {
    shop.FetchAllActiveProducts(data, (e) => {
        dispatch(viewOfAllActiveProducts(e, data));
    });
};
export const FetchUsersStatusUpdateView = (data) => (dispatch) => {
    shop.FetchUsersStatusUpdateView(data, (e) => {
        dispatch(updateStatusUser(e, data));
    });
};
export const FetchProductsStatusUpdateView = (data) => (dispatch) => {
    shop.FetchProductsStatusUpdateView(data, (e) => {
        dispatch(updateStatusUser(e, data));
    });
};

export const FetchBrandStausUpdate = (data) => (dispatch) => {
    shop.FetchBrandStausUpdate(data, (e) => {
        dispatch(updateStatusBrand(e, data));
    });
};
export const FetchAllRoleView = (data) => (dispatch) => {
    shop.FetchAllRoleView(data, (e) => {
        dispatch(contantAllviewroless(e, data));
    });
};

export const AssignPermissionsShop = (data) => (dispatch) => {
    shop.AssignPermissionsShop(data, (e) => {
        dispatch(Childassigpermissions(e, data));
    });
};

export const getAllPermissions = (data) => (dispatch) => {
    shop.getAllPermissions(data, (e) => {
        dispatch(childALLPermisssions(e, data));
    });
};

export const GetRolePermissions = (data) => (dispatch) => {
    shop.GetRolePermissions(data, (e) => {
        dispatch(rolePermissions(e, data));
    });
};

export const HandleEditUserApi = (data) => (dispatch) => {
    shop.HandleEditUserApi(data, (e) => {
        dispatch(edituserChild(e, data));
    });
};
export const HandleEditProductz = (data) => (dispatch) => {
    shop.HandleEditProductz(data, (e) => {
        dispatch(edituserChild(e, data));
    });
};

export const FetchAllBrands = (data) => (dispatch) => {
    shop.FetchAllBrands(data, (e) => {
        dispatch(allbrandgetchild(e, data));
    });
};

export const GetFaqs = (data) => (dispatch) => {
    shop.GetFaqs(data, (e) => {
        dispatch(FetchallFAQs(e, data));
    });
};

export const GetTerms = (data) => (dispatch) => {
    shop.GetTerms(data, (e) => {
        dispatch(FetchallTerms(e, data));
    });
};

export const UpdateRateLimter = (data) => (dispatch) => {
    shop.updateVerfiyLimit(data, (e) => {
        dispatch(UpdateLimit(e, data));
    });
};

export const FetchBrandOnesDetail = (data) => (dispatch) => {
    shop.FetchBrandOnesDetail(data, (e) => {
        dispatch(brandgetoneDetails(e, data));
    });
};

export const FetchBrandEditt = (data) => (dispatch) => {
    shop.FetchBrandEditt(data, (e) => {
        dispatch(brandediting(e, data));
    });
};

export const FetchAllCategeory = (data) => (dispatch) => {
    shop.FetchAllCategeory(data, (e) => {
        dispatch(getallcategeorychild(e, data));
    });
};
export const FetchAllActiveCompanies = (data) => (dispatch) => {
    shop.FetchAllActiveCompanies(data, (e) => {
        dispatch(getAllActiveCompanies(e, data));
    });
};

export const AllColorShift = (data) => (dispatch) => {
    shop.AllColorShift(data, (e) => {
        dispatch(getAllColorShift(e, data));
    });
};
export const FetchAllActiveBrands = (data) => (dispatch) => {
    shop.FetchAllActiveBrands(data, (e) => {
        dispatch(getAllActiveBrands(e, data));
    });
};

export const FetchStatusChange = (data) => (dispatch) => {
    shop.FetchStatusChange(data, (e) => {
        dispatch(categorystatusupdate(e, data));
    });
};

export const FetchStatusChangeSms = (data) => (dispatch) => {
    shop.FetchStatusChangeSms(data, (e) => {
        dispatch(SmsReplystatusupdate(e, data));
    });
};
export const SubCategoryUpdateStatus = (data) => (dispatch) => {
    shop.SubCategoryUpdateStatus(data, (e) => {
        dispatch(subcategoryupdatestats(e, data));
    });
};

export const FetchRegisterFetchCategory = (data) => (dispatch) => {
    shop.FetchRegisterFetchCategory(data, (e) => {
        dispatch(categoryfetchregister(e, data));
    });
};

export const fetchEditCategories = (data) => (dispatch) => {
    shop.fetchEditCategories(data, (e) => {
        dispatch(editcatgorychild(e, data));
    });
};

export const PostUpdateColorShift = (data) => (dispatch) => {
    shop.PostUpdateColorShift(data, (e) => {
        dispatch(editcolorshift(e, data));
    });
};

export const fetchEditSMSReply = (data) => (dispatch) => {
    shop.fetchEditSMSReply(data, (e) => {
        dispatch(editsmsReply(e, data));
    });
};

export const AllSubCategoryGet = (data) => (dispatch) => {
    shop.AllSubCategoryGet(data, (e) => {
        dispatch(subcategorygetall(e, data));
    });
};

export const AllSMSReplyGet = (data) => (dispatch) => {
    shop.AllSMSReplyGet(data, (e) => {
        dispatch(smsReplygetAll(e, data));
    });
};

export const SubCategoryEditing = (data) => (dispatch) => {
    shop.SubCategoryEditing(data, (e) => {
        dispatch(categorysubediting(e, data));
    });
};

export const CategorySubCreate = (data) => (dispatch) => {
    shop.CategorySubCreate(data, (e) => {
        dispatch(subcategorycreating(e, data));
    });
};

export const ByBatchesCSVDataGet = (data) => (dispatch) => {
    shop.ByBatchesCSVDataGet(data, (e) => {
        dispatch(actionCHildBatchesCSV(e, data));
    });
};

export const CreateSMS = (data) => (dispatch) => {
    shop.CreateSMS(data, (e) => {
        dispatch(subcategorycreating(e, data));
    });
};

export const FetchBrandOwnerClient = (data) => (dispatch) => {
    shop.FetchBrandOwnerClient(data, (e) => {
        dispatch(brandownerclientchild(e, data));
    });
};

export const FetchBrandClientRevoke = (data) => (dispatch) => {
    shop.FetchBrandClientRevoke(data, (e) => {
        dispatch(brancclientrevoke(e, data));
    });
};
export const FetchBrandClientTokenRevoke = (data) => (dispatch) => {
    shop.FetchBrandClientTokenRevoke(data, (e) => {
        dispatch(brancclienttokenrevoke(e, data));
    });
};



export const FetchBrandCLientsTokens = (data) => (dispatch) => {
    shop.FetchBrandCLientsTokens(data, (e) => {
        dispatch(branclienttokenchild(e, data));
    });
};


export const FetchCreateToken = (data) => (dispatch) => {
    shop.FetchCreateToken(data, (e) => {
        dispatch(createtokenchild(e, data));
    });
};

export const FetchCreateBrandClient = (data) => (dispatch) => {
    shop.FetchCreateBrandClient(data, (e) => {
        dispatch(brandowenerclientcrchild(e, data));
    });
};



export const FetchBrandOwnerChangePassword = (data) => (dispatch) => {
    shop.FetchBrandOwnerChangePassword(data, (e) => {
        dispatch(brandownerclientChangepasswordchild(e, data));
    });
};



export const AllCompaniesOAuth = (data) => (dispatch) => {
    shop.AllCompaniesOAuth(data, (e) => {
        dispatch(allcompanyOAUTHchild(e, data));
    });
};



export const AllCompanies = (data) => (dispatch) => {
    shop.AllCompanies(data, (e) => {
        dispatch(allcompanychild(e, data));
    });
};

export const GetProgressive = (data) => (dispatch) => {
    shop.GetProgressive(data, (e) => {
        dispatch(Progressive(e, data));
    });
};

export const AllBatches = (data) => (dispatch) => {
    shop.AllBatches(data, (e) => {
        dispatch(allBatchesActions(e, data));
    });
};

export const BatchesGetAll = (data) => (dispatch) => {
    shop.AllBatchesgettAll(data, (e) => {
        dispatch(allBatchesgetAllActions(e, data));
    });
};

export const GetAllCustomer = (data) => (dispatch) => {
    shop.GetAllCustmer(data, (e) => {
        dispatch(allCustomerGetActions(e, data));
    });
};

export const AllActiveCustomer = (data) => (dispatch) => {
    shop.GetActiveCustmer(data, (e) => {
        dispatch(allCustomerActiveActions(e, data));
    });
};

export const CreatePostCustomer = (data) => (dispatch) => {
    shop.postCustomer(data, (e) => {
        dispatch(CustomerPostActions(e, data));
    });
};

export const UpdatePostCustomer = (data) => (dispatch) => {
    shop.posteditCustomer(data, (e) => {
        dispatch(CustomerUpdateActions(e, data));
    });
};

export const UpdateIdStatus = (data) => (dispatch) => {
    shop.StatusUpdateCustomer(data, (e) => {
        dispatch(statusupdatecustomer(e, data));
    });
};

export const ExportCustomBatchAll = (data) => (dispatch) => {
    shop.ExportCustomBatchAll(data, (e) => {
        dispatch(childexportcustombattc(e, data));
    });
};

export const AllCustomBatches = (data) => (dispatch) => {
    shop.AllcustommBatches(data, (e) => {
        dispatch(allCustomBatchesActions(e, data));
    });
};

export const AllBatchesByCompany = (data) => (dispatch) => {
    shop.AllBatches(data, (e) => {
        dispatch(allBatchesCompany(e, data));
    });
};

export const AllCounts = (data) => (dispatch) => {
    shop.GetAllCounts(data, (e) => {
        dispatch(allcount(e, data));
    });
};

export const AllTransactions = (data) => (dispatch) => {
    shop.GetAllCounts(data, (e) => {
        dispatch(allcount(e, data));
    });
};

export const GetAllRandomCode = (data) => (dispatch) => {
    shop.GetAllRandom(data, (e) => {
        dispatch(viewAllRandomCode(e, data));
    });
};

export const StatusUpdateCompanies = (data) => (dispatch) => {
    shop.StatusUpdateCompanies(data, (e) => {
        dispatch(statusupdatecompany(e, data));
    });
};

export const StatusUpdateBatches = (data) => (dispatch) => {
    shop.StatusUpdateBatches(data, (e) => {
        dispatch(statusupdatecompany(e, data));
    });
};
export const HandleEditCompany = (data) => (dispatch) => {
    shop.HandleEditCompany(data, (e) => {
        dispatch(statusupdatecompany(e, data));
    });
};

export const FetchCompanyDetails = (data) => (dispatch) => {
    shop.FetchCompanyDetails(data, (e) => {
        dispatch(companydetailuser(e, data));
    });
};
export const postRandomCodes = (data) => (dispatch) => {
    shop.PostRandomCode(data, (e) => {
        dispatch(postRandomCode(e, data));
    });
};

export const PostSMSReply = (data) => (dispatch) => {
    shop.PostSMSReply(data, (e) => {
        dispatch(PostSMSReplies(e, data));
    });
};

export const ChangePassword = (data) => (dispatch) => {
    shop.ChangePassword(data, (e) => {
        dispatch(PostChangePassword(e, data));
    });
};

export const PostFAQSs = (data) => (dispatch) => {
    shop.PostFAQSs(data, (e) => {
        dispatch(PostUpdateFAQs(e, data));
    });
};

export const PostTerms = (data) => (dispatch) => {
    shop.PostTerms(data, (e) => {
        dispatch(PostUpdateTerms(e, data));
    });
};

export const PostBatch = (data) => (dispatch) => {
    shop.PostBatch(data, (e) => {
        dispatch(postRandomCode(e, data));
    });
};

export const PostCustomBatch = (data) => (dispatch) => {
    shop.PostcustommBatch(data, (e) => {
        dispatch(postCustomsbatch(e, data));
    });
};

export const PostAddCodesBatch = (data) => (dispatch) => {
    shop.PostAddCodesBatch(data, (e) => {
        dispatch(updateCustomsbatch(e, data));
    });
};

export const PostUpdateCustomBatch = (data) => (dispatch) => {
    shop.PostcustomUpdateBatch(data, (e) => {
        dispatch(updateCustomsbatch(e, data));
    });
};
export const PostUpdateBatch = (data) => (dispatch) => {
    shop.PostUpdateBatch(data, (e) => {
        dispatch(postRandomCode(e, data));
    });
};

export const ViewCustomBatch = (data) => (dispatch) => {
    shop.viewSingleCustomBatch(data, (e) => {
        dispatch(viewCustombatch(e, data));
    });
};

//Recieved SMS LOGS
export const GetAllSMSLogs = (data) => (dispatch) => {
    shop.GetAllSMSLogs(data, (e) => {
        dispatch(viewAllSMSLog(e, data));
    });
};

export const CsvDownload = (data) => (dispatch) => {
    shop.CsvDownload(data, (e) => {
        dispatch(getcsv(e, data));
    });
};

//Recieved SMS Report
export const GetAllSMSReport = (data) => (dispatch) => {
    shop.GetAllSMSReport(data, (e) => {
        dispatch(viewAllSMSReport(e, data));
    });
};

//Recieved Qrcode Report
export const GetAllQrcodeReport = (data) => (dispatch) => {
    shop.GetAllQrcodeReport(data, (e) => {
        dispatch(viewAllQrcodeReport(e, data));
    });
};

export const FetchRandomCode = (data) => (dispatch) => {
    shop.FetchRandomCode(data, (e) => {
        dispatch(fetchedallcode(e, data));
    });
};

export const GetBatchbyId = (data) => (dispatch) => {
    shop.GetAllQrcodeReport(data, (e) => {
        dispatch(viewAllQrcodeReport(e, data));
    });
};
